<template>
  <div class="lesson-comment" v-if="comment">
    <div class="tit">用户评价<div class="look-more" @click="allCommentAction">查看全部</div></div>

    <div class="cmt-wrap">
      <swiper 
        :config="swiper"
        v-if="comment.type === 'IMAGE' || comment.type === 'VIDEO'"
      >
        <div 
          class="swiper-slide comment-item comment-image"
          v-for="(cmt, index) in comment.items"
          @click="allCommentAction">
          <div class="image">
            <img :src="cmt.annex.images[0].src" v-if="cmt.annex.type === 'IMAGE'"/>
            <img :src="cmt.annex.video.coverImage.src" v-else-if="cmt.annex.type === 'VIDEO'"/>
          </div>
          <div class="user">
            <div class="info">
              <div class="avator"><img :src="cmt.evaluator.avatarUrl" /></div>
              <div class="name">{{cmt.evaluator.nickName}}</div>
            </div>
            <div class="cmt-content" v-html="cmt.content"></div>
          </div>
        </div>

        <div class="swiper-slide comment-more"><img src="https://img.thebeastshop.com/app/4.0/icon/beast-lesson/icon-more.png" @click="allCommentAction"/></div>

      </swiper>
      <div v-else class="comment-item comment-text" @click="allCommentAction">
        <div class="user">
          <div class="avator"><img :src="comment.items[0].evaluator.avatarUrl" /></div>
          <div class="info">
            <div class="name">{{comment.items[0].evaluator.nickName}}</div>
            <div class="star">
              <div class="top" :style="`width:${comment.items[0].recommend.starNumber * 20}%;}`"></div>
              <div class="btm"></div>
            </div>
          </div>
          <div class="time">{{comment.items[0].createTime | formatTime}}</div>
        </div>

        <div class="cmt-content" v-html="comment.items[0].content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '@/swiper/swiper-4.4.6/index.vue'

export default {
  components: {
    Swiper
  },

  props: ['comment', 'productId', 'sdk', 'env'],

  data () {
    return {
       swiper: {
        slidesPerView: 'auto'
      }
    }
  },

  methods: {
    allCommentAction () {
      const productId = this.productId
      
      let linkData = {
        url: `/comment?productId=${productId}`,
        mpType: 'web'
      }

      switch (this.env) {
        case 'app':
          linkData.url = `beastapp://entry?name=comment&productId=${productId}`
          break;
      }

      this.sdk.navigate.jumpTo(linkData)
    }
  },
  
  filters: {
    formatTime (time) {
      const d = new Date(time)

      let month = d.getMonth() - 0 + 1
      let date = d.getDate()

      month = month < 10 ? `0${month}` : month
      date = date < 10 ? `0${date}` : date

      return `${d.getFullYear()}-${month}-${date}`
    }
  }
}
</script>

<style lang="stylus">

</style>




// WEBPACK FOOTER //
// comment.vue?a0a42b96